export const AUTHOR_AMAZON =
  "https://www.amazon.com/s?k=Nolan+Ryan+Forbes&i=stripbooks";

export const amazonUrl = ({ asin, title, lexicon }) => {
  if (asin) return `https://www.amazon.com/dp/${asin}`;
  const q = lexicon
    ? `${title} Dictionary of Computer Programming Language Nolan Forbes`
    : `${title} Nolan Forbes`;
  return `https://www.amazon.com/s?k=${encodeURIComponent(q)}&i=stripbooks`;
};

export const LEXICON = [
  ["xpp", "X++", "B0GNSDDBH5"], ["wolfram", "Wolfram", "B0GP77DD2L"], ["v", "V", "B0GP1V6H19"], ["squirrel", "Squirrel", "B0GRSVXNKH"],
  ["cobra", "Cobra", "B0GN94FLKZ"], ["penguin", "Penguin", "B0GRN6243K"], ["yacc", "Yacc", "B0GPXFZZKR"], ["tcl", "Tcl"],
  ["swift", "Swift"], ["qsharp", "Q#"], ["odin", "Odin", "B0GNS8WQHY"], ["unrealscript", "UnrealScript", "B0GP78XH3X"],
  ["python", "Python", "B0GLWHZY9X"], ["rust", "Rust", "B0GDQ8HQTP"], ["gamemonkey", "GameMonkey", "B0GMQRTCXQ"], ["dog", "Dog", "B0GMQR1QNL"],
  ["bash", "Bash", "B0GNGLYWKH"], ["zig", "Zig", "B0GPXJPXCL"], ["cockroachdb", "CockroachDB", "B0GPXR43RX"], ["angelscript", "AngelScript", "B0GPXV79T3"],
  ["nim", "Nim", "B0GMNYS5KM"], ["lua", "Lua", "B0GMNZF44X"], ["fantom", "Fantom", "B0GNSH2B94"], ["crystal", "Crystal"],
  ["io", "Io", "B0GMNS2643"], ["perl", "Perl", "B0GDTLWLSF"], ["javascript", "JavaScript", "B0FH5FRPV9"], ["kotlin", "Kotlin", "B0GLP1DSCJ"],
  ["ruby", "Ruby", "B0GDTKR857"], ["html", "HTML & CSS", "B0GDV1RDXZ"], ["haskell", "Haskell", "B0GMQGSQ6B"], ["mojo", "Mojo", "B0GL97B555"],
  ["zebra", "Zebra", "B0GPNJG1RW"], ["fish", "Fish", "B0GPXF37BG"], ["clojure", "Clojure", "B0H64Y1B3W"], ["falcon", "Falcon", "B0GMKF2Y7D"],
  ["lisp", "Lisp", "B0GTW58WYL"], ["elixir", "Elixir", "B0GDVPCZSK"], ["grasshopper", "Grasshopper"], ["powershell", "PowerShell", "B0FH5GLTQW"],
  ["typescript", "TypeScript"],
];

export const CATEGORIES = ["All", "Psychology", "Technology", "Fiction"];

export const OTHER_BOOKS = [
  {
    id: "emergent-mind",
    asin: "B0HBBMPK4L",
    title: "The Emergent Mind",
    subtitle: "The Cultural Operating System",
    category: "Psychology",
    formats: ["Hardcover", "Paperback", "eBook"],
    featured: true,
  },
  {
    id: "echoes-of-adversity",
    asin: "B0GFKBTZSK",
    title: "Echoes of Adversity",
    subtitle: "Trauma's Role in Shaping Relational Dynamics",
    category: "Psychology",
    formats: ["Paperback", "eBook"],
  },
  {
    id: "data-to-destiny",
    asin: "B0FNLPGYG8",
    title: "Data to Destiny",
    subtitle: "AI's Influence on Human Decision Making",
    category: "Technology",
    formats: ["Hardcover", "eBook"],
  },
  {
    id: "indigenous-knowledge",
    asin: "B0G4SXMPKX",
    title: "Indigenous Knowledge Systems",
    subtitle: "The Cultural Blind Spot",
    category: "Psychology",
    formats: ["Hardcover", "eBook"],
  },
  {
    id: "unwritten-archives",
    asin: "B0FHHN6LP1",
    title: "The Unwritten Archives",
    subtitle: "Reclaiming Queer Histories",
    category: "Psychology",
    formats: ["Hardcover", "eBook"],
  },
  {
    id: "lucidity",
    asin: "B0FKMFC2JX",
    title: "Lucidity",
    subtitle: "Defining Normality in a Chaotic Universe",
    category: "Psychology",
    formats: ["Hardcover"],
  },
  {
    id: "death-mindset",
    asin: "B0FFZ8PS3W",
    title: "The Death Mindset",
    subtitle: "",
    category: "Psychology",
    formats: ["Paperback", "eBook"],
  },
  {
    id: "rip-cord-protocols",
    title: "Rip Cord Protocols",
    subtitle: "The Death Mindset · \"I'm Sorry\" Isn't Enough",
    category: "Psychology",
    formats: ["Paperback", "eBook"],
  },
  {
    id: "mathematics-macrocosm",
    asin: "B0GDZJBCS4",
    title: "The Mathematics of the Macrocosm",
    subtitle: "Cosmic Geometry in Tarot",
    category: "Psychology",
    formats: ["Paperback"],
  },
  {
    id: "twelve-step",
    asin: "B0GF14YJV9",
    title: "12 Step Dee's Nuts",
    subtitle: "A Guide to Functional Usage, Cognitive Liberty, and Self-Mastery",
    category: "Psychology",
    formats: ["Paperback"],
  },
  {
    id: "stupid-bitch",
    asin: "B0GLX1JHFH",
    title: "Try Not to Catch a Charge",
    subtitle: "A 30-Day Guide to Stress Management & Anger Control",
    category: "Psychology",
    formats: ["Paperback", "eBook"],
  },
  {
    id: "mislabeled",
    asin: "B0GPQBPW38",
    title: "Mislabeled",
    subtitle: "A Dual-Narrative Autopsy of a Shattered Psyche · 3rd Edition",
    category: "Psychology",
    formats: ["Hardcover", "eBook"],
  },
  {
    id: "ai-prompt-dictionary",
    asin: "B0FWRRGB4C",
    title: "The AI Prompt Dictionary",
    subtitle: "A Comprehensive Guide to Mastering Generative AI",
    category: "Technology",
    formats: ["Paperback", "Hardcover"],
  },
  {
    id: "dark-web-registry",
    asin: "B0FLF7QD5Q",
    title: "The Dark Web Registry",
    subtitle: "Volumes 1–3",
    category: "Technology",
    formats: ["Hardcover", "eBook"],
    volumes: [
      { label: "Vol. 1", asin: "B0FLF7QD5Q" },
      { label: "Vol. 2", asin: "B0G4JXF6MK" },
      { label: "Vol. 3", asin: "B0G4JYRBYX" },
    ],
  },
  {
    id: "desktop-dictionary",
    asin: "B0FWKK8VYD",
    title: "Desktop Dictionary & Reference",
    subtitle: "Of Computer Programming Language",
    category: "Technology",
    formats: ["Hardcover", "Paperback", "eBook"],
  },
  {
    id: "unlawful-bonds",
    asin: "B0HDGRQPBM",
    title: "Unlawful Bonds",
    subtitle: "Four Misfits, Petty Crimes, and the Accidental Road to Viral Fame",
    category: "Fiction",
    formats: ["Hardcover", "eBook"],
    coauthor: "with Renee Jones",
  },
  {
    id: "unlawful-communication",
    asin: "B0HJN7W8QB",
    title: "Unlawful Communication",
    subtitle: "A Satirical Comedy",
    category: "Fiction",
    formats: ["Paperback", "eBook"],
  },
];
